/** @format */

import { Component, input } from '@angular/core';
import { HomrProductStatsSlider, ProductStatLine } from '@shared/data-access/interfaces';

import { CommonModule } from '@angular/common';

@Component({
	standalone: true,
	imports: [CommonModule],
	selector: 'pdp-homr-sliders',
	templateUrl: './homr-stats-sliders.component.html',
	styleUrl: './homr-stats-sliders.component.scss'
})
export class HomrStatsSlidersComponent {
	productStatsSlider = input<HomrProductStatsSlider[]>();

	trackByTitle(index: number, item: HomrProductStatsSlider): string {
		return index.toString() + item.title;
	}

	trackByStatLine(index: number, item: ProductStatLine): string {
		return index.toString() + item.title;
	}
}
